import script from "./SukiSukiAcademy.vue?vue&type=script&setup=true&lang=js"
export * from "./SukiSukiAcademy.vue?vue&type=script&setup=true&lang=js"

import "./SukiSukiAcademy.vue?vue&type=style&index=0&id=25931e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25931e84"]])

export default __exports__